export default __webpack_public_path__ + "img/fe34504b856db5cfcebfcf794bf75b10.png";